import { t } from '@/core/localization';
import { BlockReason } from '@/shared/models';
export function getBlockReasonLabel(blockReason, fullText) {
    switch (blockReason) {
        case BlockReason.Defect:
            return t('defective');
        case BlockReason.Counterfeit:
            return t('counterfeit');
        case BlockReason.Undersupply:
            return t('undersupply');
        case BlockReason.Loss:
            return t('loss');
        case BlockReason.Refusal:
            return t('refusal');
        case BlockReason.Refund:
            return t('refund');
        case BlockReason.TrackableQrCodeNotFound:
            return fullText ? t('honest.sign.code.not.found') : t('honest.sign.code.not.found.short');
        default: {
            const exhaustiveCheck = blockReason;
            // throw new Error(`Unhandled BlockReason case: ${exhaustiveCheck}`);
            return `Unexpected block reason: ${exhaustiveCheck}`;
        }
    }
}
